import { render, staticRenderFns } from "./ThankYouStepper.vue?vue&type=template&id=570244fd&scoped=true&"
import script from "./ThankYouStepper.vue?vue&type=script&lang=js&"
export * from "./ThankYouStepper.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouStepper.vue?vue&type=style&index=0&id=570244fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570244fd",
  null
  
)

export default component.exports